import { gql } from '@apollo/client'

import ProductTile from '@Queries/products/tile.fragment'

import PriceFragment from './Price.fragment'

export default gql`
  ${PriceFragment}
  ${ProductTile}

  fragment LinkedProducts on LinkedProduct {
    type
    products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
      ...ProductTile
      availability {
        isInStock
      }
      masterVariant {
        restock: attribute(key: "restock") {
          ... on BaseAttribute {
            value
          }
        }
      }
    }
  }
`
